import Admin from "../components/Admin"

function AdminView() {
    return <div>
        <Admin />
    </div>;
}

export default AdminView;